import { FIND_MATCH_SETTINGS_LOADED } from 'react/redux/actions/findMatch';
import {
	DOUBLES_PARTY_LEAVE_FAILED,
	DOUBLES_PARTY_LEAVING,
	DOUBLES_PARTY_NOTICE_DISMISSED,
	DOUBLES_PARTY_RECEIVED,
} from 'react/redux/actions/doublesParty';
import {
	DECLINED,
	INVITED,
	isLiveParty,
	isPartyLeader,
	memberName,
	otherPartyMember,
} from 'react/matchmaking/findMatch/party/doublesPartyMembers';

// The player's ranked 2v2 party (seeded from my_user, then kept current by API
// responses and the doubles_party socket message). When the other member ends
// it, notice says so: { kind: 'declined' | 'cancelled' | 'left', name }.
// leavingPartyId is the party the player is leaving themself, which needs no notice.
const initialState = {
	playerId: null,
	party: null,
	notice: null,
	leavingPartyId: null,
};

function endedNotice(state, endedParty) {
	const current = state.party;
	if(state.leavingPartyId === endedParty.id) {
		return null;
	}
	const name = memberName(otherPartyMember(endedParty, state.playerId));
	if(endedParty.status === DECLINED) {
		return { kind: 'declined', name };
	}
	if(current.status === INVITED && !isPartyLeader(current, state.playerId)) {
		return { kind: 'cancelled', name };
	}
	return { kind: 'left', name };
}

function receiveParty(state, party) {
	if(isLiveParty(party)) {
		return { ...state, party, notice: null };
	}
	if(!party) {
		return { ...state, party: null, leavingPartyId: null };
	}
	// A declined or ended party only matters while it is the one we have.
	if(!state.party || state.party.id !== party.id) {
		return state;
	}
	return { ...state, party: null, notice: endedNotice(state, party), leavingPartyId: null };
}

export default (state = initialState, action) => {
	switch(action.type) {
		case FIND_MATCH_SETTINGS_LOADED: {
			const { playerId, doublesParty } = action.payload;
			return {
				...state,
				playerId: playerId === undefined ? state.playerId : playerId,
				party: doublesParty === undefined ? state.party : (isLiveParty(doublesParty) ? doublesParty : null),
			};
		}
		case DOUBLES_PARTY_RECEIVED:
			return receiveParty(state, action.payload);
		case DOUBLES_PARTY_LEAVING:
			return { ...state, leavingPartyId: action.payload };
		case DOUBLES_PARTY_LEAVE_FAILED:
			return state.leavingPartyId === action.payload ? { ...state, leavingPartyId: null } : state;
		case DOUBLES_PARTY_NOTICE_DISMISSED:
			return { ...state, notice: null };
		default:
			return state;
	}
};
